import React from 'react';
import { Table, Empty } from 'antd';

export default function Referencias(props) {
    return (
        <div>
            <Table
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText:
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='No se encontraron datos'
                        />
                }}
                columns={[
                    {
                        title: 'Tipo Comprobante',
                        dataIndex: 'tipoComprobante',
                        key: 'tipoComprobante'
                    },
                    {
                        title: 'Serie',
                        dataIndex: 'serie',
                        key: 'serie'
                    },
                    {
                        title: 'Documento',
                        dataIndex: 'documento',
                        key: 'documento'
                    }
                ]}
            />
        </div>
    );
}